import * as Types from '../../../../../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteAttachmentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type CompleteAttachmentMutation = { __typename?: 'Mutation', CompleteAttachment: { __typename?: 'Attachment', _id: string, pending: boolean, uploaded: boolean, fileName: string, extension: string, size?: number | null, url?: string | null, uploadUrl?: string | null } };


export const CompleteAttachmentDocument = gql`
    mutation CompleteAttachment($id: ID!) {
  CompleteAttachment(id: $id) {
    _id
    pending
    uploaded
    fileName
    extension
    size
    url
    uploadUrl
  }
}
    `;
export type CompleteAttachmentMutationFn = ApolloReactCommon.MutationFunction<CompleteAttachmentMutation, CompleteAttachmentMutationVariables>;

/**
 * __useCompleteAttachmentMutation__
 *
 * To run a mutation, you first call `useCompleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAttachmentMutation, { data, loading, error }] = useCompleteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteAttachmentMutation, CompleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteAttachmentMutation, CompleteAttachmentMutationVariables>(CompleteAttachmentDocument, options);
      }
export type CompleteAttachmentMutationHookResult = ReturnType<typeof useCompleteAttachmentMutation>;
export type CompleteAttachmentMutationResult = ApolloReactCommon.MutationResult<CompleteAttachmentMutation>;
export type CompleteAttachmentMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteAttachmentMutation, CompleteAttachmentMutationVariables>;